module.exports = __webpack_public_path__ + "dd53c271f4f75629126d67eb103dd6a3.png";